import { block, unblock } from '../helper/block';
import { getViewportHeight, mergeObject, isFunction } from '../helper/helper';

/**
 * Options for the infinite load class
 * data: Ajax data, must include an action for the function
 * page: Page offset - default: 2
 * wrap: Where to append elements
 * trigger: jQuery element to trigger load on click
 * callback: Function to run at the start of ajax response
 * autoInit: (bool) Always run load more on scroll
 * continue: (bool) Run load on scroll after the first trigger click (no effect on autoInit)
 * scrollOffset: (int) Screen offset from bottom of window to run the scroll load more
 */
export default class InfiniteLoad {

	constructor(options) {

		this.options = {
			data: {},
			page: 2,
			wrap: false,
			trigger: undefined,
			callback: null,
			autoInit: false,
			continue: false,
			scrollOffset: 30
		}

		this.options = mergeObject(options, this.options);

		this.ajax = null;

		this.state = {
			complete: false,
			running: false,
			enqueue: false,
			loaded: false
		};

		// if auto init is enabled then load more works off of scroll
		if (this.options.autoInit) {
			this.addScrollEvent();
		} else {
			if (this.options.continue) {
				jQuery(document.body).one('click', this.options.trigger, this.loadMoreContinuous.bind(this))
			} else {
				jQuery(document.body).on('click', this.options.trigger, this.loadMore.bind(this));
			}
		}

		jQuery(document.body).on('hpy_events_events_added', this.resetEvents.bind(this))
		jQuery(this.options.wrap).on('click', 'a', this.save.bind(this));
		this.load();
		document.addEventListener('DOMContentLoaded', this.load.bind(this));

	}

	resetEvents() {
		setTimeout(() => {
			console.log('resetting events', this.options);
			this.options.data.page = 2; // restart the page counter
			if (this.options.continue) {
				jQuery(document.body).off('click', this.options.trigger, this.loadMoreContinuous.bind(this));
				jQuery(document.body).one('click', this.options.trigger, this.loadMoreContinuous.bind(this));
				console.log('reset continue', jQuery(this.options.trigger));
			} else {
				jQuery(document.body).on('click', this.options.trigger, this.loadMore.bind(this));
			}
		}, 1000);
	}

	getTriggerElement() {
		return jQuery(this.options.trigger);
	}

	getWrapElement() {
		return jQuery(this.options.wrap);
	}

	addScrollEvent() {
		window.addEventListener('scroll', this.scroll.bind(this), { passive: true });
	}

	loadMoreContinuous() {
		this.loadMore();
		this.addScrollEvent();
	}

	// load more post types
	loadMore() {
		if (this.state.running) {
			return;
		}

		this.state.running = true;

		block(this.getTriggerElement().get(0), {
			color: 'rgba( 255,255,255, 0.9)',
			opacity: '1',
			HTML: '<div class="hpy-add-to-cart-mask"><div></div></div>'
		});

		this.ajax = jQuery.ajax({
			url: hpy.ajaxurl,
			method: 'GET',
			dataType: 'json',
			data: this.options.data,
			success: response => {

				if (response.success) {

					if (isFunction(this.options.callback)) {
						this.options.callback(response);
					} else {
						response.data.posts.forEach(post => {
							this.getWrapElement().append(post);
						});
					}

					this.options.data.page++;

					let max = jQuery('.woocommerce-result-count .max');
					if (max && response.data.total) {
						max.text(response.data.total);
					}

					const trigger = this.getTriggerElement();

					if (response.data.complete) {
						trigger.parent().hide();
						trigger.get(0).dataset.disabled = true;
						trigger.get(0).style.display = 'none';
					} else {
						trigger.parent().show();
						trigger.get(0).dataset.disabled = false;
						trigger.get(0).style.display = '';
					}

					this.getWrapElement().trigger('hpy_infinite_loaded');

					if (this.state.enqueue) {
						this.state.enqueue = false;
						this.loadMore();
					}
				}
			},
			error: error => {
				console.warn(error);
			},
			complete: () => {
				this.state.running = false;
				unblock(this.getTriggerElement().get(0));
				this.ajax = null;
			}
		});

		return this.ajax;
	}

	// maybe load more or enqueue load more on scrool if scroll offset meets requirements
	scroll() {

		if ('true' === this.getTriggerElement().get(0).dataset.disabled || this.state.enqueue) {
			return;
		}

		const offset = this.getTriggerElement().get(0).getBoundingClientRect();
		const height = getViewportHeight();
		const percentage = height / (100 / this.options.scrollOffset);
		const diff = offset.top - height;

		if (diff < percentage) {
			if (this.state.running) {
				this.state.enqueue = true;
				return;
			}
			this.loadMore();
		}
	}

	abort() {
		if (this.ajax) {
			this.ajax.abort();
		}
	}

	save(e) {
		try {

			if (e.target === this.options.trigger.get(0)) {
				return;
			}

			let html;
			let scroll;
			const page = this.options.data.page - 1;

			if (this.options.data.page > 2) {
				html = jQuery(this.options.wrap).html();
				scroll = jQuery(window).scrollTop();
			}

			sessionStorage.setItem('woo_shop_html', html || '');
			sessionStorage.setItem('woo_shop_scroll', scroll || 0);
			sessionStorage.setItem('woo_shop_page', page || 2);
			sessionStorage.setItem('woo_shop_url', window.location.origin + window.location.pathname);

			history.replaceState({ isShopRestored: true }, document.title, window.location.href);

		} catch (error) {
			console.warn(error);
		}
	}

	load() {
		if (this.state.loaded) {
			return;
		}

		this.state.loaded = true;

		try {
			const savedHtml = sessionStorage.getItem('woo_shop_html');
			const savedScroll = sessionStorage.getItem('woo_shop_scroll');
			const savedPage = sessionStorage.getItem('woo_shop_page');
			const savedUrl = sessionStorage.getItem('woo_shop_url');

			if (savedHtml && savedScroll && savedUrl && window.location.origin + window.location.pathname === savedUrl) {
				jQuery(this.options.wrap).html(savedHtml);
				const savedUrl = sessionStorage.getItem('woo_shop_url');

				if (savedPage) {
					jQuery(this.options.trigger).data('page', parseInt(savedPage));
				}

				setTimeout(function () {
					jQuery(window).scrollTop(savedScroll);

					sessionStorage.removeItem('woo_shop_html');
					sessionStorage.removeItem('woo_shop_scroll');
					sessionStorage.removeItem('woo_shop_page');
					sessionStorage.removeItem('woo_shop_url');
				}, 100);
			}
		} catch (error) {
			console.warn(error);
		}
	}
}